import React, { Component } from 'react';

const Controller = MenuComponent => class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    }
  }

  onMouseDown = url => {
    window.location.href = url;
  }

  onClickMenu = e => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  onBlurMenu = e => {
    this.setState({
      isOpen: false,
    });
  }

  render() {
    return (
      <MenuComponent
        {...this.props}
        {...this.state}
        onClickMenu={this.onClickMenu}
        onBlurMenu={this.onBlurMenu}
        onMouseDown={this.onMouseDown} />
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./client/components/Header/MenuComponent/Controller.js